import React from 'react';
import { IconStarBold, IconStarSolid } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { numberInTenThousandWithFloor } from '@common/utils';
import { TouchAccessibilityWrapper } from '@domains/pdp-common';

import { BookmarkStatus } from '../services/useBookmarkService';

interface BookmarkProps {
  is_preview: boolean;
  is_visible_bookmark_count: boolean;
  bookmark_status: BookmarkStatus;
  setBookmark: (e: React.MouseEvent) => void;
}
export const Bookmark: React.FC<React.PropsWithChildren<BookmarkProps>> = ({
  is_preview,
  is_visible_bookmark_count,
  bookmark_status,
  setBookmark,
}) => {
  return (
    <TouchAccessibilityWrapper touchWidth={48} touchHeight={48} onClick={setBookmark}>
      <ShopBookmark isPreview={is_preview}>
        {bookmark_status.isBookmarked ? (
          <IconStarSolid width={24} height={24} v3Color='pink400' />
        ) : (
          <IconStarBold width={24} height={24} v3Color='gray400' />
        )}
        {is_visible_bookmark_count && (
          <BookmarkCount>{numberInTenThousandWithFloor(bookmark_status.bookmarkCount)}</BookmarkCount>
        )}
      </ShopBookmark>
    </TouchAccessibilityWrapper>
  );
};

const ShopBookmark = styled.div<{ isPreview?: boolean }>`
  width: 28px;
  display: flex;
  align-items: center;
  flex-direction: column;

  ${({ isPreview }) =>
    isPreview &&
    css`
      > svg {
        opacity: 0.4;
      }
    `}
`;

const BookmarkCount = styled.span`
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  white-space: pre;
  color: ${vars.color.textTertiary};
`;
